<div class="container-fluid py-4">

    <!-- PAGE TITLE -->
    <div class="row mb-4">
        <div class="col-12">
            <h3 class="fw-bold text-primary">
                <i class="fa fa-file-excel me-2"></i>
                Reports
            </h3>
        </div>
    </div>

    <div class="row g-4">

        <!-- ===================================================== -->
        <!-- CURRENT STOCK REPORT -->
        <!-- ===================================================== -->

        <div class="col-lg-6">

            <div class="card shadow-lg border-0 h-100">

                <div class="card-header bg-success text-white">

                    <div class="d-flex justify-content-between align-items-center">

                        <div>

                            <h5 class="mb-1">
                                <i class="fa fa-cubes me-2"></i>
                                Current Stock Report
                            </h5>

                            <small>
                                Download current stock between selected dates.
                            </small>

                        </div>

                        <i class="fa fa-file-excel fa-3x opacity-50"></i>

                    </div>

                </div>

                <div class="card-body">

                    <div class="row">

                        <div class="col-md-6 mb-3">

                            <label class="form-label fw-bold">
                                From Date
                            </label>

                            <input type="date" class="form-control" [(ngModel)]="stockFromDate"
                                [max]="stockToDate || todayMax" (change)="onStockDateChange()">

                        </div>

                        <div class="col-md-6 mb-3">

                            <label class="form-label fw-bold">
                                To Date
                            </label>

                            <input type="date" class="form-control" [(ngModel)]="stockToDate" [max]="todayMax"
                                (change)="onStockDateChange()">

                        </div>

                    </div>

                    <div class="text-center py-5" *ngIf="!showStockTable">

                        <i class="fa fa-table fa-4x text-success mb-3"></i>

                        <h6 class="text-muted">
                            Click the Eye icon to view the stock report.
                        </h6>

                    </div>

                    <div class="table-responsive" *ngIf="showStockTable">

                        <div class="table-style table-responsive table-bordered">
                            <table class="table table-head-fixed text-nowrap text-center">

                                <thead class="table-success">

                                    <tr>

                                        <th>#</th>
                                        <th>Product</th>
                                        <th>Barcode</th>
                                        <th>Size</th>
                                        <th>SRP</th>
                                        <th>Stock</th>
                                        <th>Date</th>
                                    </tr>

                                </thead>

                                <tbody>

                                    <tr *ngFor="let item of getAllVariantDetails; let i=index">

                                        <td>{{i+1}}</td>

                                        <td>{{item?.productName || "-"}}</td>

                                        <td>{{item?.barcodeNumber || "-"}}</td>

                                        <td>{{item?.size || "-"}}</td>

                                        <td>{{(item?.productSrp | currency:'INR') || 0}}</td>

                                        <td>{{item?.availableStock || 0}}</td>

                                        <td>{{(item?.updatedAt | date : "dd-MM-yyyy") || "-"}}</td>

                                    </tr>

                                    <tr *ngIf="getAllVariantDetails.length==0">

                                        <td colspan="7" class="text-center text-danger">

                                            No records found

                                        </td>

                                    </tr>

                                </tbody>

                            </table>

                        </div>

                    </div>


                </div>

                <div class="card-footer bg-white">

                    <div class="d-flex gap-2">

                        <button class="btn btn-outline-primary flex-fill" (click)="viewCurrentStockReport()">

                            <i class="fa fa-eye"></i>
                            View Details
                        </button>

                        <button class="btn btn-success flex-fill" (click)="downloadCurrentStockReport()"
                            [disabled]="getAllVariantDetails.length == 0">

                            <i class="fa fa-download"></i>
                            Download Excel
                        </button>

                    </div>

                </div>

            </div>

        </div>



        <!-- ===================================================== -->
        <!-- DAILY SALES REPORT -->
        <!-- ===================================================== -->

        <div class="col-lg-6">

            <div class="card shadow-lg border-0 h-100">

                <div class="card-header bg-primary text-white">

                    <div class="d-flex justify-content-between align-items-center">

                        <div>

                            <h5 class="mb-1">

                                <i class="fa fa-chart-line me-2"></i>

                                Daily Sales Report

                            </h5>

                            <small>

                                Download sales report between dates.

                            </small>

                        </div>

                        <i class="fa fa-calendar fa-3x opacity-50"></i>

                    </div>

                </div>

                <div class="card-body">

                    <div class="row">

                        <div class="col-md-6 mb-3">

                            <label class="form-label fw-bold">

                                From Date

                            </label>

                            <input type="date" class="form-control" [(ngModel)]="fromDate" [max]="toDate || todayMax"
                                (change)="onDate()">

                        </div>

                        <div class="col-md-6 mb-3">

                            <label class="form-label fw-bold">

                                To Date

                            </label>

                            <input type="date" class="form-control" [(ngModel)]="toDate" [max]="todayMax"
                                (change)="onDate()">
                        </div>

                    </div>


                    <div class="text-center py-5" *ngIf="!showSalesTable">

                        <i class="fa fa-table fa-4x text-success mb-3"></i>

                        <h6 class="text-muted">
                            Click the Eye icon to view the sales report.
                        </h6>

                    </div>

                    <div class="table-responsive mt-3" *ngIf="showSalesTable">

                        <div class="table-style table-responsive table-bordered">
                            <table class="table table-head-fixed text-nowrap text-center">

                                <thead class="table-primary">

                                    <tr>

                                        <th>S.No</th>
                                        <th>Invoice No</th>
                                        <th>Date</th>
                                        <th>Customer Name</th>
                                        <th>Phone</th>
                                        <th>City</th>
                                        <th>State</th>
                                        <th>Tracking No</th>
                                        <th>Weight</th>
                                        <th>Bill Type</th>
                                        <th>Subtotal</th>
                                        <th>Product Discount</th>
                                        <th>Manual Discount</th>
                                        <th>Total Amount</th>
                                        <th>Balance</th>
                                        <th>Payment Method</th>
                                        <th>Total Items</th>
                                        <th>Shipping Partner</th>
                                        <th>Transaction Ref</th>
                                        <th>Shipping Amount</th>
                                        <th>Status</th>
                                        <th>Remarks</th>

                                    </tr>

                                </thead>

                                <tbody>

                                    <tr *ngFor="let bill of getAllShopBillDetails; let i = index">

                                        <td>{{ i + 1 }}</td>

                                        <td>{{ bill?.invoiceNumber || '-' }}</td>

                                        <td>{{ bill?.invoiceDate || '-' }}</td>

                                        <td>{{ bill?.customerName || '-' }}</td>

                                        <td>{{ bill?.phoneNumber || '-' }}</td>

                                        <td>{{ bill?.city || '-' }}</td>

                                        <td>{{ bill?.state || '-' }}</td>

                                        <td>{{ bill?.trackingNumber || '-' }}</td>

                                        <td>{{ bill?.weight || '-' }}</td>

                                        <td>{{ bill?.billingType || '-' }}</td>

                                        <td>{{ formatIndianCurrency(bill?.subTotal) }}</td>

                                        <td>{{ formatIndianCurrency(bill?.discount) }}</td>

                                        <td>{{ formatIndianCurrency(bill?.manualDiscountAmount) }}</td>

                                        <td>{{ formatIndianCurrency(bill?.totalAmount) }}</td>

                                        <td>{{ formatIndianCurrency(bill?.dueAmount) }}</td>

                                        <td>{{ bill?.paymentMethod || '-' }}</td>

                                        <td>{{ bill.products?.length || 0 }}</td>

                                        <td>{{ bill?.shippingPartner || '-' }}</td>

                                        <td>{{ bill?.transactionRefId || '-' }}</td>

                                        <td>{{ formatIndianCurrency(bill?.shippingAmount) }}</td>

                                        <td>{{ bill?.billingStatus || '-' }}</td>

                                        <td>{{ bill?.note || '-' }}</td>

                                    </tr>

                                    <tr *ngIf="getAllShopBillDetails.length === 0">

                                        <td colspan="22" class="text-center text-danger fw-bold">

                                            No Records Found

                                        </td>

                                    </tr>

                                </tbody>

                            </table>

                        </div>

                    </div>

                </div>

                <div class="card-footer bg-white">

                    <div class="d-flex gap-2">

                        <button class="btn btn-outline-primary flex-fill" (click)="viewCurrentSalesReport()">

                            <i class="fa fa-eye"></i>
                            View Details
                        </button>

                        <button class="btn btn-success flex-fill" [disabled]="!fromDate || !toDate"
                            (click)="downloadDailySalesReport()">

                            <i class="fa fa-download"></i>
                            Download Excel
                        </button>

                    </div>

                </div>

            </div>

        </div>

    </div>

</div>